import { render, staticRenderFns } from "./ProductionStatCard.vue?vue&type=template&id=e63e3726"
import script from "./ProductionStatCard.vue?vue&type=script&lang=js"
export * from "./ProductionStatCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports